import CloseIcon from "@mui/icons-material/Close";
import { Dialog, Grid, IconButton, Slide } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import appcolors from "../../../constants/Colors";
import SelectedClient from "./SelectedClient";
import SelectedServices from "./SelectedServices";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-container": {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-end",
  },
  "& .MuiPaper-root": {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    maxWidth: "55%",
    margin: 0,
    overflow: "visible !important",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      maxWidth: "100% !important",
    },
  },

  "& .MuiDialog-icon-btn": {
    position: "absolute",
    top: "20px",
    left: "-55px",
    zIndex: 999,
    backgroundColor: appcolors.white,
    "&:hover": {
      backgroundColor: appcolors.white,
    },
    [theme.breakpoints.down("md")]: {
      top: 6,
      right: 6,
      left: "inherit",
    },
  },
}));

let paramsData = {};

const BookedAppointmentDialog = forwardRef(({ handleFetchEvents }, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    isVisible(params) {
      paramsData = params;
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      TransitionComponent={Transition}
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      scroll="body"
    >
      <IconButton className="MuiDialog-icon-btn" onClick={handleClose}>
        <CloseIcon />
      </IconButton>

      <Grid container flexWrap={"wrap-reverse"} height={"100vh"}>
        <Grid item xs={12} md={5}>
          <SelectedClient data={paramsData} setOpen={setOpen} />
        </Grid>
        <Grid
          item
          xs={12}
          md={7}
          sx={{ borderLeft: { md: `1px solid ${appcolors.primary}` } }}
        >
          <SelectedServices
            handleCloseDialog={handleClose}
            data={paramsData}
            handleFetchEvents={handleFetchEvents}
          />
        </Grid>
      </Grid>
    </BootstrapDialog>
  );
});

export default BookedAppointmentDialog;
